import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import App from '@components/App/index';

registerWithErrorBoundary({
  App,
});
